module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view note",
    attrs: {
      "id": "quick-note"
    }
  }, [_c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', [_c('div', {
    staticClass: "top"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentTime))])]), _vm._v(" "), _vm._m(1, false, false)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "toolbar"
  }, [_c('li', [_c('a', {
    staticClass: "close-note-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "pg-arrow_left"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "data-action": "Bold"
    }
  }, [_c('i', {
    staticClass: "fa fa-bold"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "data-action": "Italic"
    }
  }, [_c('i', {
    staticClass: "fa fa-italic"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "quick-note-editor full-width full-height js-input",
    attrs: {
      "contenteditable": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45043332"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/note_editor.vue
// module id = 1305
// module chunks = 1